//@ts-check
import React from 'react';
import { Field } from 'react-final-form';
/**
 * @param {import('./types').FormConditionProps} props
 */

var ConditionField = function ConditionField(_ref) {
  var when = _ref.when,
      is = _ref.is,
      not = _ref.not,
      children = _ref.children;
  return React.createElement(Field, {
    name: when,
    subscription: {
      value: true
    }
  }, is === undefined ? not === undefined ? function () {
    return null;
  } : function (_ref2) {
    var value = _ref2.input.value;
    return value !== not ? children : null;
  } : function (_ref3) {
    var value = _ref3.input.value;
    return value === is ? children : null;
  });
};

ConditionField.defaultProps = {
  is: undefined,
  not: undefined
};
export default ConditionField;